export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'tongren-xiaoshuo',
    name: '同人小说',
    description: '原创火影忍者同人小说创作，涵盖各种世界观与剧情走向，从短篇到长篇，点燃你的创作灵感。',
    icon: 'ri-book-read-line',
    imageSeq: 'cat-novel',
  },
  {
    slug: 'tongren-chahua',
    name: '同人插画',
    description: '火影忍者同人插画作品欣赏与创作教程，从线条到上色，画出你心中的忍者世界。',
    icon: 'ri-brush-line',
    imageSeq: 'cat-illustration',
  },
  {
    slug: 'cp-tongren',
    name: 'CP同人',
    description: '火影CP配对分析与同人创作，鸣佐、佐樱、卡带等热门CP深度解读与创作指南。',
    icon: 'ri-hearts-line',
    imageSeq: 'cat-cp',
  },
  {
    slug: 'tongren-juqing',
    name: '同人剧情',
    description: '火影忍者同人原创剧情设计，平行世界、IF线、角色重塑，打造属于你的忍者传说。',
    icon: 'ri-movie-2-line',
    imageSeq: 'cat-plot',
  },
  {
    slug: 'chuangzuo-jiaocheng',
    name: '创作教程',
    description: '从零开始的同人创作教程，新人入门必备。写作技巧、绘画基础、角色塑造全攻略。',
    icon: 'ri-graduation-cap-line',
    imageSeq: 'cat-tutorial',
  },
];